<script lang="ts" module>
	/** Each shape: a line drawn thick, used as the mask, in a box of its own size. */
	export const paths = {
		'1_1-01': {
			height: 510,
			width: 506,
			path: 'M431 119.001C431 119.001 377 75.0013 255 75C133 74.9987 75.5 119.001 75.5 119.001L316 208.999L431 252.503H252H75.5L245 322.5L358 363L431 390.003C431 390.003 370 434.5 255 434.5C140 434.5 75.5 390.003 75.5 390.003',
			stroke: 150
		},
		'1_1-02': {
			height: 503,
			width: 503,
			path: 'M440 62.5L62.5 86.5L440 182.5L62.5 206.5L440 301.5L62.5 325.5L440 417.5L62.5 440.5',
			stroke: 125
		},
		'1_1-03': {
			height: 504,
			width: 503,
			path: 'M438 65.5H65.5L438 192.5H65.5L438 317.5H65.5L438 438.5H65.55',
			stroke: 130
		},
		'3_4-01': {
			height: 400,
			width: 298,
			path: 'M236.5 78.9537C236.5 78.9537 204.57 58.7212 149.686 60.4307C94.8023 62.1401 60.5 84.7488 60.5 84.7488L195.5 178.773L237.5 200.404L126.635 178.773L60.5 206.5L235.5 316.712C235.5 316.712 194.416 339.341 140.63 339.341C86.8442 339.341 60.5 323 60.5 323',
			stroke: 120
		},
		'3_4-02': {
			height: 646,
			width: 481,
			path: 'M83 179.5C83 179.5 131.407 107.997 250.407 88.9988C369.407 70.0011 397.5 105.497 397.5 105.497C397.5 105.497 312 179.5 250.407 216C188.814 252.5 83 360.5 83 360.5L397.5 284.5C397.5 284.5 298.75 383 239 417.5C179.25 452 83 540.5 83 540.5C83 540.5 147.407 581.5 254.5 552C361.593 522.5 397.5 463.5 397.5 463.5',
			stroke: 165
		},
		'3_4-03': {
			height: 642,
			width: 482,
			path: 'M417 65.5H65.5L417 166.5H65.5L417 270.5H65.5L417 369.5H65.5L417 475.5H65.5L417 577H65.5',
			stroke: 130
		},
		'3_4-04': {
			height: 639,
			width: 481,
			path: 'M418 62.5L62.5 86.5L418 187.5L62.5 211.5L418 311.5L62.5 335.5L418 432.5L62.5 455.5L418 552.5L62.5 576.5',
			stroke: 125
		},
		'4_3-01': {
			height: 380,
			width: 508,
			path: 'M143.501 300C143.501 300 97.8251 248.935 86.4999 194.75C75.1747 140.565 83.4998 80 83.4998 80L282.5 296L227.001 82.5L425.001 296C425.001 296 431.947 246.685 421.5 192.5C411.053 138.315 370 82.5 370 82.5',
			stroke: 160
		},
		'4_3-02': {
			height: 381,
			width: 508,
			path: 'M423 5.58984L85 4.58984L254 94.6603L423 188.731H85C85 188.731 186.049 247.322 254 284.865C321.951 322.408 423 377 423 377H85',
			stroke: 170
		},
		'5_6-01': {
			height: 607,
			width: 494,
			path: 'M408 124.5C408 124.5 348 82.4054 248 85.5028C148 88.6001 85.5 135 85.5 135L304 243.5L408 306.504L206 265.5L85.5 315.004L408 481.004C408 481.004 329.5 522.004 231.5 522.004C133.5 522.004 85.5 490.004 85.5 490.004',
			stroke: 170
		},
		'5_6-02': {
			height: 596,
			width: 494,
			path: 'M80 164.501C80 164.501 129.407 105.997 248.407 86.9991C367.407 68.0014 413.5 99.4976 413.5 99.4976L80 336.5L413.5 267.5L80 501.5C80 501.5 143.5 529.075 258 507C372.5 484.925 413.5 431.5 413.5 431.5',
			stroke: 160
		},
		'5_6-03': {
			height: 601,
			width: 503,
			path: 'M438 65.5H65.5L438 186.5H65.5L438 302.5H65.5L438 419.5H65.5L438 535.5H65.5',
			stroke: 130
		},
		'5_6-04': {
			height: 600,
			width: 499,
			path: 'M439 60.5L60.5 83.5L439 176.5L60.5 196.5L439 292.5L60.5 312.5L439 406.5L60.5 429.5L439 517.5L60.5 539.5',
			stroke: 120
		},
		'6_5-01': {
			height: 367,
			width: 436,
			path: 'M396 40.5L40.5 66L396 104.5L40.5 128.5L396 172L40.5 196L396 237.5L40.5 263.5L396 303L40.5 326.5',
			stroke: 80
		},
		'6_5-02': {
			height: 341,
			width: 406,
			path: 'M346 60.5H60.5L346 171.5H60.5L346 280.5H60.5',
			stroke: 120
		},
		'6_5-03': {
			height: 359,
			width: 431,
			path: 'M371 81.5L60.5 60.5L371 189.5L60.5 170.5L371 298.5L60.5 277.5',
			stroke: 120
		},
		'6_5-04': {
			height: 431,
			width: 507,
			path: 'M452 87.0024C452 87.0024 395 50.0399 271.5 56.5001C148 62.9602 68 98.0022 55 115.503C119 161.002 388 146.5 452 205C352 270.5 128.5 181 55 233.5C100 267.5 452 318.5 452 318.5C452 318.5 385 366.839 249.5 374.5C114 382.161 58.5 348.5 58.5 348.5',
			stroke: 110
		},
		'6_5-05': {
			height: 385,
			width: 463,
			path: 'M372.5 7.58984L90.5 6.58984L234.5 96.6603L372.5 190.731H90.5L234.5 286.865L372.5 379H90.5',
			stroke: 180
		},
		'6_5-06': {
			height: 499,
			width: 599,
			path: 'M413.5 418.499C413.5 418.499 488.932 337.5 509.5 239C530.068 140.5 507 80 507 80L251 418.499L346.5 80L88.5 418.499C88.5 418.499 68.4999 354.999 92.9999 248.499C117.5 141.999 185.5 80 185.5 80',
			stroke: 160
		},
		'16_9-01': {
			height: 302,
			width: 535,
			path: 'M433.5 80H80.5L455 222H103.5',
			stroke: 160
		},
		'16_9-02': {
			height: 303,
			width: 543,
			path: 'M432 80L80 98.5L462.5 203.5L108 222.5',
			stroke: 160
		},
		'16_9-03': {
			height: 307,
			width: 541,
			path: 'M486 89.9967C445.5 65.4962 348.1 51.1322 271 55.9971C197.271 60.6492 133.5 72 55 114.999C245.5 178.997 264 114.999 486 190.497C451.5 221.497 347 248.497 257 250.997C184.705 253.005 117 246.997 56.5 217.997',
			stroke: 110
		},
		'16_9-04': {
			height: 323,
			width: 574,
			path: 'M493.25 0.5H80L493.25 160H80L493.25 323H80',
			stroke: 160
		}
	} as const
</script>

<script lang="ts">
	import Image from '#components/image.svelte'
	import { genID } from 'kitto'

	interface Props {
		src: string
		alt?: string | null
		name?: keyof typeof paths | ''
		focus?: string | undefined | null
	}

	let { src, alt, name: rawName = '5_6-02', focus = undefined }: Props = $props()

	const hasShape = $derived(Boolean(rawName && rawName in paths))
	const name = $derived(hasShape ? rawName || '5_6-02' : '5_6-02')
	const id = genID()
</script>

{#if hasShape}
	<figure
		class="shape"
		height={paths[name]?.height}
		width={paths[name]?.width}
		style:--height={paths[name]?.height}
		style:--width={paths[name]?.width}
	>
		<svg
			class="svg"
			viewBox="0 0 {paths[name].width} {paths[name].height}"
			fill="none"
			preserveAspectRatio="xMidYMid meet"
		>
			{#if src}
				<mask id="mask_{id}" maskUnits="userSpaceOnUse">
					<path
						d={paths[name].path}
						stroke="white"
						stroke-width={paths[name].stroke}
						stroke-linecap="round"
						stroke-linejoin="round"
						fill="none"
					/>
				</mask>
				<Image
					{src}
					{alt}
					width={paths[name].width}
					height={paths[name].height}
					{focus}
					fill
					mask="mask_{id}"
				/>
			{:else}
				<path
					d={paths[name].path}
					stroke="currentColor"
					stroke-width={paths[name].stroke}
					stroke-linecap="round"
					stroke-linejoin="round"
					fill="none"
				/>
			{/if}
		</svg>
	</figure>
{:else if src}
	<figure class="shape shape--plain">
		<Image {src} {alt} {focus} aspect="5/6" fill />
	</figure>
{/if}

<style lang="css">
	.shape {
		aspect-ratio: var(--width, 494) / var(--height, 596);
		color: var(--c-foreground);
		max-height: calc((var(--height, 596)) * 1px);
		max-width: min(calc((var(--width, 494)) * 1px), 100%);
	}
</style>
